import Swiper from 'swiper/bundle'

export default class GallerySlider {
	constructor() {
		this.sliderContainers = document.querySelectorAll('.gallery-swiper')

		if (this.sliderContainers.length === 0) return

		this.swiperInstances = []
		this.#init()
	}

	#init() {
		this.sliderContainers.forEach(sliderContainer => {
			this.#setUpSwiper(sliderContainer)
		})
		requestAnimationFrame(() => this.#applyParallax())
	}

	#clamp(v, min, max) {
		return Math.max(min, Math.min(max, v))
	}

	#applyParallax() {
		const viewportCenter = window.innerWidth / 2
		this.swiperInstances.forEach(swiper => {
			swiper.slides.forEach(slide => {
				const rect = slide.getBoundingClientRect()
				const t = this.#clamp((rect.left + rect.width / 2 - viewportCenter) / viewportCenter, -1, 1)
				const img = slide.querySelector('img')
				if (img) img.style.transform = `translateX(${-t * 20}%)`
			})
		})
		requestAnimationFrame(() => this.#applyParallax())
	}

	#setUpSwiper(container) {
		const swiper = new Swiper(container, {
			speed: 750,
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 16,

			autoplay: {
				delay: 2000,
				disableOnInteraction: false,
			},
		})

		this.swiperInstances.push(swiper)
	}
}
